import React, {useEffect, useState} from 'react';
import { searchUtils } from '../assets/js/searchUtils';
import { Link, navigate } from 'gatsby';
import { useDispatch } from 'react-redux';
import { setSearchState } from '../state/searchState';

const SidebarSearch = ({props}) => {

	const [keywordArray, setKeywordArray] = useState([]);
	const [filteredKeywords, setFilteredKeywords] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const dispatch = useDispatch();

	const navigateToSearch = () => {
    navigate("/knowledge-exchange/search")
  }

	const selectKeyword = (event, keyword) => {
		event.preventDefault()
		//event.stopPropagation()
		let searchCriteria = 'any';
		// if keyword is multiple words set criteria to 'all words'
		if (keyword.split(" ").length > 1) {
			searchCriteria = 'all';
		} else {
			searchCriteria = checkforAIterm(keyword);
		}
		setSearchTerm(keyword);
		dispatch(setSearchState({searchTerm: keyword, searchCriteria: searchCriteria}));
		navigateToSearch();
  }

	const checkforAIterm = (term) => {
		let srcCrit = "any";
		if (term.trim().toLowerCase() === "ai" ) {
			srcCrit = "phrase";
		}
		return srcCrit;
	}

	const filterKeywords = (searchVal) => {
		let filtered = [];
		searchVal = searchVal.replace(/  +/g, ' ');
		setSearchTerm(searchVal);
		let searchValArray = searchVal.trim().split(" ");
		let term = "";
		let myRE = new RegExp();
		let allConfirmation = true;
		let matchAllResult = {};
		let matchResults = [];

		for (let i=0; i < keywordArray.length; i++) {
			allConfirmation = true;
			for (let j=0; j < searchValArray.length; j++) {
				term = searchUtils.sanitizeInput(searchValArray[j]);
				myRE = new RegExp(term, "gi");
				matchAllResult = keywordArray[i].matchAll(myRE);
				matchResults = Array.from(matchAllResult);
				if (matchResults?.length > 0) {
					// console.log(keywordArray[i] + " contains :" + term)
				} else {
					allConfirmation = false;
					break;
				}
			}
			if (allConfirmation) {
				filtered.push(keywordArray[i]);
			}
		}
		setFilteredKeywords(filtered);
 };

 const handleKeyPress = (e) => {
	if (e.key === 'Enter') {
		if (searchTerm !== '') {
			let searchCrit = checkforAIterm(searchTerm);
			dispatch(setSearchState({searchTerm: searchTerm, searchCriteria: searchCrit}));
			navigateToSearch();
		}
	}
 };

 const handleClickSearchBut = (e) => {
	if (searchTerm !== '') {
		let searchCrit = checkforAIterm(searchTerm);
		dispatch(setSearchState({searchTerm: searchTerm, searchCriteria: searchCrit}));
		navigateToSearch();
	}
 };

  useEffect(() => {

			let allKeywords = [];
			let postKeyWords = "";
			let thisPostKeyword = "";
			let postKeywordArray = [];
			
			props.allPosts.forEach((post, index) => {
				if (post.keywords) {
					postKeyWords = post.keywords;
					postKeywordArray = postKeyWords.split(",");
					postKeywordArray.forEach((keywd, index) => {
						thisPostKeyword = keywd.toLowerCase().trim();
						if (thisPostKeyword !== '') {
							allKeywords.push(thisPostKeyword);
						}
					});
				}
			});
			allKeywords.sort();
			let uniqueKeywords = new Set(allKeywords);
			let autoCompleteArray = [];
			uniqueKeywords.forEach((kwd, index) => {
				autoCompleteArray.push(kwd)
			});
			setKeywordArray(autoCompleteArray);
			

  }, []);

    return (
        <>
					
					<div class="dropdown">
						<div class="input-group mb-3">
							<input type="text" class="form-control dropdown-toggle" placeholder="search Knowledge Exchange" aria-label="search Knowledge Exchange" id="dropdownMenuButton2" data-bs-toggle="dropdown" autocomplete="off" onKeyDown={handleKeyPress} onChange={(event) => filterKeywords(event?.target?.value)} value={searchTerm} />
							<button class="btn btn-outline-secondary" type="button" id="button-search" title="search" onClick={(e) => handleClickSearchBut()}><i class="bi bi-search"></i></button>
							<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2" style={{visibility: searchTerm.length > 0 ? 'visible' : 'hidden' }}>
								{filteredKeywords.map((kwd, idx) => (
									<li key={idx}><a class="dropdown-item" href="#" onClick={(e) => selectKeyword(e, kwd)}>{kwd}</a></li>
								))}
							</ul>
						</div>
					</div>

        </>
    );
}

export default SidebarSearch;
